import {createStore} from '@web/helpers/redux'

import {CheckoutRootState} from '../../interfaces'

import Middlewares from './middlewares'
import {uiEventActions} from './middlewares/uiEventLoggerMiddleware'
import createRootReducer from './reducer'
import FamilyCheckoutSentryEnhancer from './sentryEnhancer'

/** 맴버십 주문서 store */
const store = createStore<CheckoutRootState>({
    rootReducerCreator: createRootReducer,
    middlewares: Middlewares,
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [...uiEventActions],
        },
    },
    sentryEnhancerOptions: FamilyCheckoutSentryEnhancer,
})

export default store
